import {
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";

const toDisplayText = (value) => {
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  if (value && typeof value === "object") {
    return value.ar || value.en || Object.values(value).find((item) => typeof item === "string") || "";
  }

  return "";
};

const getMenuButtonStyles = (isActive) => ({
  bg: isActive
    ? "linear-gradient(135deg, #7c3aed 0%, #06b6d4 100%)"
    : "white",
  color: isActive ? "white" : "#1A202C",
  border: "1px solid",
  borderColor: isActive ? "#7c3aed" : "#E2E8F0",
  borderRadius: "md",
  px: 2,
  py: 1,
  fontWeight: "600",
  mx: 1,
  transition: "all 0.2s ease",
  boxShadow: isActive
    ? "0 2px 8px rgba(124, 58, 237, 0.3)"
    : "0 1px 4px rgba(0, 0, 0, 0.1)",
  fontSize: "14px",
  minHeight: "20px",
  _hover: {
    bg: isActive
      ? "linear-gradient(135deg, #6d28d9 0%, #059bb4 100%)"
      : "linear-gradient(135deg, #1484f3ff 0%, #157adfff 100%)",
    transform: "translateY(-1px)",
    boxShadow: isActive
      ? "0 4px 12px rgba(124, 58, 237, 0.4)"
      : "0 3px 8px rgba(0, 0, 0, 0.15)",
    borderColor: isActive ? "#6d28d9" : "#1e7de2ff",
    color: isActive ? "white" : "#1A202C",
  },
  _active: { transform: "translateY(0)" },
});

export const ReportPickerMenu = ({
  activeLabel,
  activeIcon,
  defaultLabel,
  isActive,
  items,
  onSelect,
}) => (
  <Menu>
    <MenuButton sx={getMenuButtonStyles(isActive)}>
      <HStack spacing={2}>
        <Icon as={activeIcon} boxSize="14px" />
        <Text fontSize="sm" fontWeight="600" noOfLines={1}>
          {toDisplayText(activeLabel) || toDisplayText(defaultLabel)}
        </Text>
        <Icon as={FaChevronDown} boxSize="12px" />
      </HStack>
    </MenuButton>
    <MenuList minW="200px" p={1}>
      {items.map((item) => (
        <MenuItem
          key={item.key}
          onClick={() => onSelect(item.index)}
          sx={{
            bg: item.isSelected
              ? "linear-gradient(135deg, #7c3aed 0%, #06b6d4 100%)"
              : "white",
            color: item.isSelected ? "white" : "#2D3748",
            borderRadius: "sm",
            px: 3,
            py: 1,
            mb: 0.5,
            fontSize: "13px",
            _hover: {
              bg: item.isSelected
                ? "linear-gradient(135deg, #6d28d9 0%, #059bb4 100%)"
                : "gray.50",
            },
          }}
        >
          <HStack spacing={2}>
            <Icon as={item.icon} boxSize="12px" />
            <Text fontSize="sm">{toDisplayText(item.label)}</Text>
          </HStack>
        </MenuItem>
      ))}
    </MenuList>
  </Menu>
);
